import personalBookImgSrc from '../assets/images/Profile/personal_choice.png';

// endpoint for finding cover image for a book
const imageLookupBase = '/prc/system/getWebFile.html';

export function gradeString(g) {
    if (!g) return '';
    if (g.slice(0, 4) === 'Year' || g === 'K - Year 2' ) return g;
    if (g.toUpperCase() === 'K-2') {
        return 'K - Year 2'
    } else {
        return g.split('-').map(g => `Year ${g}`).join(' - ')  // e.g '3-4' => 'Year 3 - Year 4'
    }
}

export const normaliseBooks = (books) => books.map(book => {
    const officialImgSrc = (book.imagePresent || book.image_present_yn === 'Y') ?
        `${imageLookupBase}?taxonomy=BOOKLIST_COVER&filename=${book.isbn}.jpg` : '';
    const imageSrc = (book.isOfficial === false || book.isOfficial === 'F') ? personalBookImgSrc : officialImgSrc;

    return {
        ...book,
        imageSrc,
        isHighGradeBook: book.difficultRead || book.difficult_read_yn === 'Y',
        grade: gradeString(book.readingLevel || book.grade),
        series: book.series || book.seriesName,
        genre: book.genre || book.categories,
        readingLevel: book.readingLevel || book.grade,
        isOfficial: book.isOfficial === true || book.isOfficial === 'T' || book.type_name === 'PRC Book List',
    };
});

export const normaliseReadingLog = readingLog => ({
    ...readingLog,
    books: normaliseBooks(readingLog.books),
});

export const normaliseReadingPlan = readingPlan => ({
    ...readingPlan,
    books: normaliseBooks(readingPlan.books),
});
